<p class="counter-bid-disclosure">
  <b>Counter Bidding: </b>
  Until the seller's reserve price is met, RealtyBid.com may counter bid on behalf of the seller. Counter bidding gives buyers and sellers more flexibility to
  find a mutually agreeable price. Counter bids do not occur after the seller's reserve price is met.
</p>
